<template>
  <div class="draft-search">
    <div class="head-tip-content flex">
      <WFormCreator ref="searchForm" :options="options">
        <template #after>
          <el-button type="primary" @click="fnSearch">查询</el-button>
          <el-button type="caicai" @click="exportExcel">批量导出</el-button>
          <el-button @click="refreshSearch">重置</el-button>
        </template>
      </WFormCreator>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import { httpAgent } from "@/api/ajax";

export default {
  name: "DraftSearch",
  props: {
    content: String,
  },
  data () {
    return {
      options: {
        fnSearch: this.fnSearch,
        formItemAttrs: {
          masterBillNo: { type: 'input', label: '主提单号', placeholder: '请输入主提单号', width: '320px' },
          houseBillNo: { type: 'input', label: '分提单号', placeholder: '请输入分提单号', width: '320px' },
          // containerNo: { type: 'input', label: '箱号', placeholder: '请输入箱号', width: '180px' },
          shipName: { type: 'input', label: '船名', placeholder: '请输入船名', width: '320px',toUpper:true },
          voyageNo: { type: 'input', label: '航次', placeholder: '请输入航次', width: '180px',toUpper:true },
          newOperator: {
            type: 'select',
            label: '提交人',
            selectOpts: [],
            placeholder: '请选择提交人'
          },
          gmtModified: { type: 'daterange', label: '编辑时间', width: '320px' },
        }
      }
    }
  },
  created(){
    //this.getSubmitUserList()
  },
  methods: {
    refreshTime(){
      let nowDate = new Date(new Date().getFullYear(),new Date().getMonth(),new Date().getDate(),'23','59','59')
      this.$refs.searchForm.setFormData({
        gmtModified: [moment(nowDate.getTime() - 3600 * 1000 * 24 * 31 + 1000).format('YYYY-MM-DD HH:mm:ss'), moment(nowDate.getTime()).format('YYYY-MM-DD HH:mm:ss')]
      })
    },
    async firstClick(){
      await this.getSubmitUserList()
      let nowDate = new Date(new Date().getFullYear(),new Date().getMonth(),new Date().getDate(),'23','59','59')
      await this.$refs.searchForm.setFormData({
        gmtModified: [moment(nowDate.getTime() - 3600 * 1000 * 24 * 31 + 1000).format('YYYY-MM-DD HH:mm:ss'), moment(nowDate.getTime()).format('YYYY-MM-DD HH:mm:ss')]
      })
    },
    // 提交人列表
    async getSubmitUserList(){
      await httpAgent({
        url: `/agent/ccam/customs/submitUserList`,
        method: "get",
      }).then((res) => {
        let arr = []
        res.forEach(item => {
          arr.push({
            label: item.nickName,
            value: item.userId,
          })
        })
        this.options.formItemAttrs.newOperator.selectOpts = arr
      })
    },
    fnSearch (query) {
      this.$emit('fnSearch', this.$refs.searchForm.getFormData())
    },
    // 重置
    refreshSearch(){
      this.$refs.searchForm.resetForm()
      this.$emit('refreshSearch')
    },
    // 导出
    exportExcel(){
      this.$emit('exportExcel', { ...this.$refs.searchForm.getFormData(), type: 'DRAFT' })
    }
  }
};
</script>

<style scoped lang="less">
.draft-search {
  border-radius: 4px;
  .head-tip-content {
    padding-left: 24px;
    font-size: 14px;
    margin-bottom: 10px;
  }
}
</style>